import serviceADX from "@/helpers/py-service";

const state = {
  loading: false,
  list: [],
  //
  chargerAvailability: {},
  downtime: {},
  ftcsr: {},
};

const mutations = {
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_LOADING_LIST(state, value) {
    state.loading = value;
  },
  SET_CHARGE_AVAILABILITY(state, payload) {
    state.chargerAvailability = payload;
  },
  SET_DOWNTIME(state, payload) {
    state.downtime = payload;
  },
  SET_FTCSR(state, payload) {
    state.ftcsr = payload;
  },
};

const actions = {
  setLoadingValue: (store, value) => {
    store.commit("SET_LOADING_LIST", value);
  },
  list: (store, params) => {
    store.state.loading = true;
    return serviceADX
      .get("charging-station/csms-dashboard", params)
      .then((data) => {
        store.commit("SET_LIST", data.body);
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },
  chargerAvailability: (store, params) => {
    store.state.loading = true;
    return serviceADX
      .get("charging-station/charger-availability", params)
      .then((data) => {
        store.state.loading = false;
        store.commit("SET_CHARGE_AVAILABILITY", data.body);
        return data.body;
      });
    // .finally(() => (store.state.loading = false));
  },
  downtime: (store, params) => {
    // store.state.loading = true;
    return serviceADX
      .get("charging-station/downtime-classification", params)
      .then((data) => {
        store.commit("SET_DOWNTIME", data.body);
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },
  ftcsr: (store, params) => {
    // store.state.loading = true;
    return serviceADX
      .get("charging-station/ftcsr", params)
      .then((data) => {
        store.commit("SET_FTCSR", data.body);
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },
};

const getters = {
  getLoading(state) {
    return state.loading;
  },
  getList(state) {
    return state.list;
  },
  getChargerAvailability(state) {
    return state.chargerAvailability;
  },
  getDowntime(state) {
    return state.downtime;
  },
  getFtcsr(state) {
    return state.ftcsr;
  },
};

const csmsDashboard = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default csmsDashboard;
